import { RULE_SUBTYPES, RULE_TYPES } from "globals/constants";

export default {
	attachmentTypes: {
		components: {
			toggle: {
				activeText: "Active",
				inactiveText: "Inactive",
				tip: "At least one attachment type must be active"
			}
		},
		manageAttachmentTypes: "Manage Attachment Types",
		manageProjectAttachmentTypes: "Manage Project Attachment Types",
		attachmentTypeGuidance: "Users will select an attachment type when uploading a file to Sponsored Projects, Types that should not be available to users may be toggled off.",
		attachmentTypeContentHeader: "Proposal, Award, and Subaward Attachment Types",
		projectAttachmentTypeContentHeader: "Project Attachment Types",
		titleColHeader: "Attachment Type Title",
		activeColHeader: "Active",
		addAttachmentType: "Add New Attachment Type",
		modalHeader: "Create a new attachment type.",
		modalContent: `Enter a title for your new attachment type and click "Save", your new attachment type will be added to the list and set to active.`,
		modalGuidance: `Click "cancel" to discard changes and return to list.`,
		inputPlaceholder: `Attachment Type...`,
		errorNoTitle: "Title must not be empty or all whitespace.",
		errorDuplicateTitle: "Title must be unique.",
		cancel: "Cancel",
		saveAttachment: "Save"
	},
	awards: {
		accessibilityLabelAwardNumber: "Award #",
		awardsSearchAriaLabel: "Search awards",
		assignedToMeOnly: "See assigned to me only",
		awardDetails: {
			breadcrumbRoot: "My Active Awards",
			tabLabels: {
				account: "Account",
				attachments: "Attachments",
				form: "Award Form",
				history: "Award History",
				funds: "Funds",
				relatedRecords: "Related Records",
				negotiations: "Negotiations",
				notes: "Notes",
				routing: "Routing",
				subawards: "Subawards",
				tasks: "Tasks"
			},
			summary: {
				title: "Award Summary",
				errors: {
					noComment: "A comment is required",
					noDecision: "A review decision is required",
					unableToSave: "Unable to complete the review",
					reviewNotCompleted: "The review could not be completed. Please click save again.",
					statusNotChanged: "The status could not be changed. Please try again."
				},
				certification: {
					buttonLabel: "Certify Award",
					cancelLabel: "Cancel",
					errors: {
						notConfirmed: "Please check the Confirm checkbox",

					},
					fields: {
						confirmPlaceholder: "Confirm my Certification",
						comment: "Comment",
						commentPlaceholder: "Please add a comment."
					},
					modalTitle: "Confirm Certification",
					modalTitleSeparator: "for",
					saveLabel: "Certify",
				},
				completeReview: {
					buttonLabel: "Complete Review",
					completeAll: 'Complete all Reviews',
					cancelLabel: "Cancel",
					decisions: {
						approved: "Approve",
						defer: "Defer"
					},
					errors: {
						noComment: "A comment is required",
						noDecision: "A review decision is required",
						unableToSave: "Unable to complete the review",
						reviewNotCompleted: "The review could not be completed. Please click save again.",
						statusNotChanged: "The status could not be changed. Please try again."
					},
					fields: {
						reviewDecision: "Review Decision",
						reviewDecisionPlaceholder: "Review Decision",
						comment: "Comment",
						commentPlaceholder: "Please add a comment."
					},
					modalTitle: "Complete Review",
					modalTitleSeparator: "for",
					modalTitleMultipleRules: "Multiple Rules",
					saveLabel: "Save",
					taskTypeHeaderDisplays: {
						UNIT: "Unit",
						TEAM: "Team",
						RESEARCH: "Research Team"
					},
				},
				routeForReview: "Route for Review",
			},
			history: {
				currentlyAssigned: "Currently Assigned",
				currentlyAssignedNone: "None",
				editAssignmentLabel: "edit",
				unknownUser: "Unknown User",
				unknownRole: "Unknown Role",
				columnHeaders: {
					action: "Action",
					name: "Name",
					date: "Date",
					comment: "Comment"
				},
				reviewCommentLabel: "view",
				cancelCommentLabel: "Cancel",
				assignedPrefix: "Award assigned to ",
				unassignedPrefix: "Award unassigned from ",
				commentModal: {
					title: "Status Comment"
				}
			}
		},
		filePrefix: "SP_Awards",
		noResults: "No Saved Awards",
		routing: {
			columnHeaders: {
				team: "Team",
				members: "Members",
				status: "Status",
				date: "Date",
				comment: "Comment"
			},
			commentModal: {
				titleWithCreator: "Routing Comment from",
				titleWithoutCreator: "Routing Comment"
			},
			decisions: {
				approved: "Approved",
				deferred: "Deferred",
				pending: "Pending",
				notCompleted: "Not Completed",
				emptyStatus: "Not Yet Active",
				skipped: "Skipped",
			},
			certification: {
				certified: "Certified",
				pending: "Pending",
				notCompleted: "Not Completed",
				emptyStatus: "Not Yet Active",
				skipped: "Skipped",
			},
			errors: {
				noRouting: "This award has not yet been routed for review. Information about the review process will be displayed once routing has begun.",
				unableToLoad: "Unable to load routing information",
				routeReviewFailed: "Reviews could not be routed. Please try again.",
				unknownTeam: "Unknown, team cannot be found",
			},
			sectionHeading: "Routing for Review",
			viewComment: "view",
		},
		startNewAward: {
			addToProjectLabel: "<b>Add to existing project</b> (create a new award on an existing project, copy an award or a proposal to create a new award)",
			awardSearchLabel: "Select award",
			backButton: "Back",
			cancel: "Cancel",
			createAwardButton: "Create Award",
			createFromAwardLabel: "<b>Create award from an award </b> (new award will be added to the same project as the original award)",
			createFromProposalLabel: "<b>Create award from a proposal </b> (award will be added to the same project as proposal)",
			createNewAward: "Create New Award",
			createNewProjectLabel: "<b>Create a new project</b> (create a new project and award at the same time)",
			creatingAward: "Creating award",
			createProjectAndAwardButton: "Create Project and Award",
			creatingProjectAndAward: "Creating project and award",
			errors: {
				notAuthorized: "The action is not authorized. Please contact an administrator to check your permissions.",
				default: "There was an error while trying to process your request. Please try again later.",
				failedToCopy: "Failed to copy data from form. A new form may have been created with no data.",
				missingLabel: "One or more labels are missing on the form you are trying to copy from. Copying from this form will not work",
				noActionSelected: "Please select where to create a new award",
				noAwardSelected: "Please select a project",
				noProjectTitle: "Please enter a project title",
				projectTitleLengthValidation: "Project title must be less than 256 characters",
				noProjectSelected: "Please select a project",
				noProposalSelected: "Please select a project",
				duplicateLabelsMsg: "Duplicate Labels - Unselect sections that contain duplicate labels to copy data from remaining selections.Remove duplicate Labels from the form to prevent this error from occurring on future forms.",
				section: "Section",
				question: "Question",
				label: "Label",
			},
			newLabel: "Name project",
			nextButton: "Next",
			projectSearchPlaceholder: "Enter new project name...",
			projectSearchAwardPlaceholder: "Click to search by award number, project title or PI",
			projectSearchProposalPlaceholder: "Click to search by proposal number, project title or PI",
			proposalSearchLabel: "Select proposal",
			selectSections: "Select sections to copy",
			startNew: "Start New Award",
			addNew: "Add An Award",
			successMessages: {
				fromProposal: "Successfully created award from proposal!",
				fromAward: "Successfully created award from award!",
				fromSource: "Successfully created award from source!",
				create: "Successfully created new project and award!"
			}
		},
		startNewSubaward: {
			cancel: "Cancel",
			confirmNewSubaward: "Create New Subaward",
			confirmNewSubawardAria: "Creating subaward",
			disabledReason: "Loading Sections For Selection",
			errors: {
				default: "There was an error while trying to process your request. Please try again later.",
				failedToCopy: "Failed to copy data from form. A new form may have been created with no data.",
				missingLabel: "One or more labels are missing on the form you are trying to copy from. Copying from this form will not work"
			},
			selectSections: "Select sections to copy",
			startNew: "Add A Subaward",
		}
	},
	subawards: {
		accessibilityLabelSubawardNumber: "Subaward #",
		subawardsSearchAriaLabel: "Search subawards",
		assignedToMeOnly: "See assigned to me only",
		filePrefix: "SP_Subawards",
		noResults: "No Saved Subawards",
		captionText: "Project Subawards",
		startNewSubaward: {
			addToProjectLabel: "<b>Add to project</b> (create a new subaward linked directly to a project)",
			subawardSearchLabel: "Select award",
			subawardSearchPlaceholder: "Click to search by award number, project title, or PI",
			subawardProjectSearchPlaceholder: "Click to search by award number",
			backButton: "Back",
			cancel: "Cancel",
			createSubawardButton: "Create Subaward",
			createNewSubaward: "Create New Subaward",
			createNewProjectLabel: "<b>Create new project</b> (create a new project and new subaward at the same time)",
			creatingSubward: "Creating subaward",
			creatingProjectAndSubaward: "Creating subaward",
			addToAwardLabel: "<b>Add to award </b> (create a new subaward linked to an award)",
			errors: {
				notAuthorized: "The action is not authorized. Please contact an administrator to check your permissions.",
				default: "There was an error while trying to process your request. Please try again later.",
				failedToCopy: "Failed to copy data from form. A new form may have been created with no data.",
				missingLabel: "One or more labels are missing on the form you are trying to copy from. Copying from this form will not work",
				noActionSelected: "Please select where to create a new subaward",
				noProjectTitle: "Please enter a project title",
				projectTitleLengthValidation: "Project title must be less than 256 characters",
				noProjectSelected: "Please select a project",
				noAwardSelected: "Please select an award",
				duplicateLabelsMsg: "Duplicate Labels - Unselect sections that contain duplicate labels to copy data from remaining selections.Remove duplicate Labels from the form to prevent this error from occurring on future forms.",
				section: "Section",
				question: "Question",
				label: "Label",
			},
			newLabel: "Enter a title for the project",
			nextButton: "Next",
			projectSearchPlaceholder: "New project title",
			proposalSearchLabel: "Select proposal",
			selectSections: "Select sections to copy",
			startNew: "Start New Subaward",
			addNew: "Add A Subaward",
			searchProjectLabel: "Click to search by Project Number or Project Title",
			successMessages: "Subaward has been successfully created"
		},
		errors: {
			loadParentError: "Parent award didn’t load successfully. Please refresh the page to try again.",
			subawardFailedLoad: "Subaward information didn’t load successfully. Please refresh the page to try again.",
			subawardListFailedLoad: "The subawards didn’t load successfully. Please refresh the page to try again.",
			tilesFailedLoad: "Information for the summary tiles didn’t load successfully. Please refresh the page to try again."
		},
		subawardDetails: {
			breadcrumbRoot: "My Active Awards",
			breadcrumbProjectRoot: "My Active Subawards",
			tabLabels: {
				form: "Subaward Form",
				history: "History",
				tasks: "Tasks",
				notes: "Notes",
				attachments: "Attachments"
			},
			summary: {
				title: "Subaward Summary",
				errors: {
					noComment: "A comment is required",
					noDecision: "A review decision is required",
					unableToSave: "Unable to complete the review",
					reviewNotCompleted: "The review could not be completed. Please click save again.",
					statusNotChanged: "The status could not be changed. Please try again.",
					noAwardViewAccess: "You do not have permission to view the parent award. Please contact an administrator to check your permissions."
				},
			},
			errors: {
				noAwardViewAccess: "You do not have permission to view the parent award. Please contact an administrator to check your permissions."
			}
		}
	},
	agreements: {
		title: "Agreements",
		noRecords: "No related records.",
		addNewAgreement: "Add Related Record",
		removeAgreementTitle: "Remove link?",
		removeAgreementButton: "Remove link",
		removeAgreementDescription: "Removing this link from the project level will also remove it from any awards within this project.",
		noAgreementProduct: "Agreements is not provisioned on this tenant.",
		startNewAgreement: {
			cancel: "Cancel",
			confirm: "Add Link",
			createNew: "Add Related Record",
			linkToExistingAgreement: "Link an existing Agreement record",
			searchPlaceholder: "Search for Agreement by ID, Title, or Principal Investigator",
			createAgreemnet: "Create and link a new Agreement record",
			agreementTitle: "Agreement Title",
			agreementType: "Agreement Type",
			adminUnit: "Admin Unit",
			agreementStatus: "Agreement Status",
			enterTitle: "Enter Agreement Title",
			selectUnit: "Search for a Unit",
			selectType: "Select Agreement Type",
			selectStatus: "Select Agreement Status",
			errors: {
				titleLengthValidation: "Agreement title must be less than 256 characters.",
				noActionSelected: "Please select an option",
				noAgreementSelected: "Please select an agreement",
				noData: "Please enter valid data",
				loadStatusesError: "Unable to retrieve agreement information, please refresh page or come back to this tab later.",
				searchError: "Unable to retrieve matching agreement information, please try again later.",
				createError: "Unable to create agreement, please try again later.",
				linkError: "Unable to link agreement, please try again later.",
			}
		},
		errors: {
				loadError: "Unable to retrieve linked agreement information, please refresh page or come back to this tab later.",
				deleteError: "Unable to remove link, please try again later.",
			}
	},
	common: {
		assignSelected: {
			assignRoles: "Assign Roles",
			assignSelected: "Assign selected",
			clear: "Clear",
			selectPerson: "Select Person",
			selectRole: "Select Role",
			selectRolePlaceholder: "Select a Role...",
			selectPersonPlaceholder: "Select a Person...",
			errors: {
				addTeamMemberFails: "That person could not be assigned. Please try again, or try assigning to someone else.",
				removeTeamMemberFails: "That person could not be unassigned. Please try again."
			}
		},
		confirmationModal: {
			cancelButtonLabel: 'Cancel',
			confirmButtonLabel: 'Confirm'
		},
		commentDisplayModal: {
			cancelCommentLabel: "Cancel",
			columnHeaders: {
				comment: "Comment"
			}
		},
		downloadCsv: {
			cancelButtonLabel: "Cancel",
			downloadButtonLabel: "Download to CSV",
			heading: "Select columns for download to CSV. There is no limit to the number of columns that can be selected for download.",
			selectAll: "Select All",
			title: "Download to CSV",
			triggerButtonLabel: "Download to CSV",
			downloadingProgress: `Creating CSV. Large files may take some time to be created.\nFiles will automatically download.\nNavigating away from this page will cancel the download.`,
			error: "Unable to generate report. Please try again. If the issue persists, please contact support.",
			errorLoadingBlob: "Unable to load Report data."
		},
		dropdown: {
			noResultsMessage: "No results found"
		},
		exteranlRecords: {
			title: "External Records",
			noRecords: "No External Records have been added yet."
		},
		form: {
			failGetFormDetails: "Details about this form could not be loaded. Please reload the page to try again.",
			ruleCantBeSaved: "The rule didn’t save. Please try again.",
			saveError: "An error occurred and your changes have not been saved.",
			saveErrorWithRefresh: "An error occurred and your changes have not been saved. Please reload the page and try again.",
			successSaveMsg: "Your changes have been saved",
			preventLeaveMessage: "Leave page? Changes you made will not be saved",
			actions: {
				editBtn: "Edit",
				cancelBtn: "Cancel",
				saveBtn: "Save",
				otherUserEditing: "There is currently another user editing this record.",
			}
		},
		conflictsModal: {
			title: "Another user made changes to the same field(s). Review the impacted field(s) below. If your change is still desired, re-enter your value into the field.",
			enteredValue: "Your entered value",
			currentValue: "Current value",
		},
		formEditWarning: {
			ruleFieldAffected: "The changed field below is associated with a review rule. Changing the value may impact the routing chain for this record. Be sure to confirm the change is desired before saving the updated value.",
			accessFieldAffected: "The changed field below impacts which users have access to this record. Be sure to confirm the change is desired before saving the updated value.",
			researchTeamLabel: "Research Team Object",
		},
		retryModal: {
			title: "Another user continues to make changes to the same field(s) that are overwriting your inputs. Review the impacted field(s) below. Since this conflict has occurred multiple times, please refresh your page and try again later.",
			enteredValue: "Your entered value",
			currentValue: "Current value",
		},
		formResponse: {
			genericFormError: "Unable to load the form.",
			sectionComplete: "Required questions are complete <br> and section has been viewed",
			sectionUnseen: "Section must be viewed",
			invalidInput: "This section has an invalid input, please review all values within it",
			sectionIncomplete: "Section has required questions",
			unableLoadData: "Unable to load form data. Please refresh the page and try again.",
			anotherUserEditingWarning: "Another user started editing this record. Only one user can edit a record while in this status.",
			statusChangedToCloseMsg: "Changes you made were not saved due to a status change. Contact a SP System Administrator to make the edit.",
			statusChangedToOpenMsg: "Changes you made were not saved. The record was moved back to an editable status. Please refresh and make the changes again.",
			attachmentDownloadFailed: "Unable to download the attachment. Please try downloading it again.",
			modificationUnavailable: "The modification is not available for this award. Refresh the page.",
			recordNotEditable: "Record can’t be updated because its state is not editable. Refresh the page.",
		},
		formSaving: {
			defaultText: "All changes save automatically",
			savingText: "Saving...",
			saveCompleteText: "Changes Saved!",
			preventLeavePageMessage: "The form is saving. Are you sure you want to leave the page?",
			inactivityMessage: "Your editing session ended due to inactivity. Changes you made were not saved.",
		},
		groupRoles: {
			rolesNotFound: "Something went wrong. Please try again."
		},
		noteDisplayModal: {
			cancelEditNote: "Cancel",
			saveEditNote: "Save",
			lengthError: "Maximum amount of characters (5,000) exceeded.",
		},
		notes: {
			actions: {
				save: "Save"
			},
			addNote: "Add a note",
			addNoteAttachment: "Add Notes and Attachments",
			columnHeaders: {
				note: "Note",
				updatedBy: "Last Updated By",
				sortByLastUpdated: "Sort by Last Updated Date",
				date: "Date"
			},
			confirmationModal: {
				title: "Delete Note"
			},
			noteModal: {
				viewTitle: "Note Details",
				editTitle: "Edit Note"
			},
			error: "The status could not be changed. Please try again",
			lengthError: "Maximum amount of characters (5,000) exceeded.",
			notePlaceholder: "Enter your note text here...",
			unknownUser: "Unknown User",
			msgTooLong: "Note is too long."
		},
		notifications: {
			defaultErrorMsg: "Unexpected error. If the problem persists, please contact support.",
			login: "Login",
			loginMessage: "Session has expired. Please login."
		},
		picklist: {
			genericError: "Something went wrong. Please try again.",
			cantPullData: "The options for this field couldn’t be found. Please refresh and try again."
		},
		setView: {
			cancel: "Cancel",
			instructions: "Choose which columns to view on the table. This table can show a maximum of eleven columns at a time.",
			noOptions: "Unable to find columns for this list",
			triggerButtonLabel: "Set View",
			update: "Update"
		},
		table: {
			noResults: "No Results",
			selectAll: "Select all",
			selectRow: "Select row"
		},
		shell: {
			failedLoadingData: "Something went wrong loading SP. Please try again, or contact Cayuse Support if the issue persists."
		},
		tenant: {
			entryNotSaved: "Those changes could not be saved. Please try again.",
			changesNotSaved: "Those changes could not be saved. Please try again."
		},
		userFinder: {
			placeholder: "Search for a person...",
			searchingMessage: "Searching..."
		},
		userTask: {
			someTasksNotLoaded: "There may be some tasks that haven’t loaded, and aren’t displaying here. Refresh to view all tasks.",
			submitReviewStalls: "The review could not be saved. Try submitting again now, or try again later."
		},
		fieldValidation: {
			emptyField: "Field must not be empty",
			numberField: "Field value must be a number",
		}
	},
	distributionTable: {
		totalAmount: "Total Expected Amount",
		obligatedAmount: "Obligated Amount",
		distributed: "Distributed",
		remainingDistributed: "Remaining to be Distributed"
	},
	fundDistribution: {
		title: "Funds & Distribution Summary",
		emptyMsg: "Funds will apear here.",
		currencyValueMsg: "Please enter a currency value.",
		removeExtraspacesMsg: "Please remove extra spaces and try again.",
		invalidSpecSymbolsMsg: "The only special characters allowed are _ and -",
		specSymbolsMsg: "Fund number may not start with a _ or -",
		enterValidFundMsg: "Please enter a valid fund number",
		emptyStatusMsg: "Please select an fund status.",
		selectStatusLabel: "Select a status...",
		saveBtn: "Save",
		fundTableHeader: "Fund",
		distributedTableHeader: "Distributed",
		statusTableHeader: "Fund Status",
		addBtn: "Add Fund",
		sectionLabel: "Fund & Distribution Summary"
	},
	fundManager: {
		searchDropdown: {
			placeholder: "Search by fund code, name, or PI...",
			searchingMessage: "Loading...",
		},
		warningPopup: {
			text: "This link will open Fund Manager. Dependent upon your permissions within Fund Manager you may or may not see data that is consistent with what is visible in Sponsored Projects. If you have concerns about your Fund Manager permissions, please contact your system administrator. Click \"continue\" to open Fund Manager.",
			title: "Warning: Potential for inconsistent data",
			doNotShowMsg: "Don't show me this again.",
		},
		awardBurndown: {
			awardBurndownTitle: "Award Burndown",
			info: "This information shows the health of the award and the amount of funds left on each fund that the award is pulling from.",
			link: "Link to fund in Fund Manager",
			accountNotFound: "Account (Fund) number not found. If this is a new account, it may not yet be present in the Fund Manager.",
			nothingFound: "Nothing has been selected yet.",
			title: "Link to fund in Fund Manager",
		},
		fundView: {
			primaryResearcher: "PI",
			fundCode: "Fund Code",
			fundName: "Fund Name",
			obligated: "Obligated",
			obligatedDC: "Direct Cost",
			obligatedFA: "F&A",
			obligatedTotal: "Total",
			expensesToDate: "Expenses to Date",
			expensesToDateDC: "Direct Cost",
			expensesToDateFA: "F&A",
			expensesToDateTotal: "Total",
			budgetHeader: "Budget Remaining",
			budgetRemainingDC: "Direct Cost",
			budgetRemainingFA: "F&A",
			budgetRemainingTotal: "Total",
		}
	},
	dashboard: {
		heading: "SP Dashboard"
	},
	reporting: {
		awardHeader: "Award Reporting",
		subawardHeader: "Subaward Reporting",
		proposalHeader: "Proposal Reporting",
		tableHeadings: {
			name: "Report Name",
			created: "Created By",
			dataSet: "Data Set"
		},
		popup: {
			title: "Select Data for Report",
			description: "Select data for report columns. The more data fields that are selected, the longer the report will take to generate.",
			buttonLabel: "Generate Report"
		},
		loader: {
			label: "Creating report.",
			description: " Reports with large amounts of data may take some time to be created. Navigating away from this page will cancel report creation."
		},
		errors: {
			errorParsingJson: "Saved Report has incorrect format."
		}
	},
	infoCards: {
		SECTION_HEADER: "SECTION_HEADER"
	},
	formManager: {
		breadcrumbRoot: "Forms",
		errors: {
			invalidContent: "We are sorry! The form has not been imported due to an invalid file!",
			invalidType: "We are sorry! The form has not been imported due to a type mismatch!",
			obfuscate: "We are sorry! The form has not been exported due to an error!"
		},
		deploymentTimeNever: "Never",
		heading: "Form Manager",
		importErrorModalTitle: "Error",
		importInfoModalConfirmButtonLabel: "Okay",
		importInfoModalMessage: "Would you like to import a new form? This will override the in-draft revision.",
		importInfoModalTitle: "Form Import",
		importSuccessModalConfirmButtonLabel: "Okay",
		importSuccessModalMessage: "The form has been imported successfully.",
		importSuccessInfoModalTitle: "Form Import",
		tableHeadings: {
			type: "Type",
			published: "Published"
		},
		uploadButtonAriaLabel: "Upload form",
		downloadButtonAriaLabel: "Download form"
	},
	formDesigner: {
		closePreview: "Close Preview",
		manageForm: "Manage Form",
		manageFormRules: "Form Rules",
		manageFormRevisions: "Revisions",
		preview: "Preview",
		saveDraft: "Save Draft",
		publish: "Publish",
		publishConfirmation: {
			title: "Would you really like to publish all forms?",
			description: "Please confirm that you want to publish all your forms for your Sponsored Project."
		},
		notifications: {
			draftFail: "The draft could not be saved",
			draftSuccess: "The draft was saved",
			publishFail: "The form could not be published",
			publishSuccess: "The form was published",
			foundSubformElement: "This form contains a subform object type on the {{sectionLabel}} section. In previous releases, this object was available to add to a form, but provided no function and could not be populated with any data. This object type has now been removed from the form builder and is no longer supported. The existing subform object will be removed upon the next save of this form.",
			formContainsSubform: "This form contains a subform object type",
			subformNeedsToBeRemoved: "In previous releases, this object could be added to a form, but provided no function and could not be populated with any data. In this release, this object type is no longer supported. In future releases, the ability to add this object type will be removed. For now, the subform object type must be removed manually before the form can be published.",
			unmatchedRules: "The form cannot be published because one or more rules conditions aren't attached to questions on the form. <br /> Please reset them and try again.",
			invalidElements: "Issues have been found with the form that will prevent some features from working. The following issues must be remedied before the form can be published.",
			unknownTeams: "The form cannot be published because one or more rules reference a team that does not exist. Please reset them and try again.",
			noValue: "Value attribute is missing",
		},
	},
	formManagerHistory: {
		breadcrumbRoot: "Template Manager",
		goBackButtonLabel: "Cancel and go back",
		heading: "Template Preview",
		inDraftRevision: "In-Draft Revision",
		nextButtonLabel: "Next",
		previousButtonLabel: "Previous",
		publishedOn: "Published on",
		restoreRevisionButtonLabel: "Restore revision",
		restoreRevisionConfirmationModalMessage: "Any changes made to your draft revision will be lost. Are you sure you want to restore Revision",
		restoreRevisionConfirmationModalTitle: "Restore this revision",
		revision: "Revision",
		revisionHistory: "Revision History",
		tableHeadings: {
			revisions: "Revisions"
		}
	},
	irbStudy: {
		headline: "Link to Cayuse IRB Study 123",
		description: "Please select a study that you wish to link to this proposal",
		findIrbStudy: "Find IRB Study",
		studyFinder: "Study Finder",
		study: "Study",
		title: "Title",
		approvalDate: "Approval Date",
		expireDate: "Exp. Date",
		primaryInvestigator: "PI",
		status: "Status"
	},
	modifications: {
		common: {
			buttons: {
				cancel: "Cancel",
				close: "Close",
				continue: "Continue",
				setToActive: "Set to Active",
				setToActiveTooltip: "Activates modification and leaves award in current status",
				routeForReview: "Route for Review",
				routeForReviewTooltip: "Activates modification, moves award back to the In Review & Negotiation status, and routes the latest award version for review",
				delete: "Delete Modification",
				modify: "Modify",
				save: "Set Modification to Active",
				changeStatusActive: "Change Status to Active",
				changeStatusClosed: "Change Status to Closed"
			},
			explanation: "As modifications are made, they will appear in this list. Modifications can only be made to the most recent form in “active” or “in closeout” status.",
			feedTable: {
				noResults: "No Saved Modifications",
			},
			modal: {
				deleteModification: {
					header: "Delete Modification",
					text: "There is no way to restore this modification once it’s deleted. Are you sure you want to delete it?"
				},
				comment: {
					title: "Modification Comment"
				},
				delete: {
					message: "There is no way to restore this modification once it’s deleted. Are you sure you want to delete it?",
					title: "Delete Modification",
					closeLabel: "Close",
					deleteLabel: "Delete Modification",
				},
				modify: {
					dropdownPlaceholder: "select...",
					label: "Reason For Modification",
					title: "Modify",
				},
				activate: {
					commentLabel: "Comment",
					checkReasonText: "Please check that the reason is still correct, and leave a comment.",
					dropdownPlaceholder: "select...",
					label: "Reason For Modifying",
					title: "Set modification to Active",
				}
			},
			placeholders: {
				modificationTypeDropdown: "select..."
			},
			viewComment: "view",
			warning: {
				inDraft: "This is a draft modification.",
			}
		},
		award: {
			buttons: {
				modify: "Modify Award"
			},
			currentForm: "Currently Viewing Award Form: ",
			modal: {
				changeStatusActive: {
					header: "Change Award Status to Active",
					text: "Once a award is active a new modification can be added, but it cannot be edited. Are you sure you want to make it active now?"
				},
				changeStatusClosed: {
					header: "Change Award Status to Closed",
					text: "Once an award is closed, the original award and all modifications will be closed and can no longer be edited. Are you sure you want to close it now?"
				},
				modifyForm: {
					header: "Modify Award",
					label: "Reason for modifying award",
				}
			},
		},
		proposal: {
			buttons: {
				modify: "Modify Proposal"
			},
			currentForm: "Currently Viewing Proposal Form: ",
			modal: {
				changeStatusActive: {
					header: "Change Proposal Status to Active",
					text: "Once a proposal is active a new modification can be added, but it cannot be edited. Are you sure you want to make it active now?"
				},
				changeStatusClosed: {
					header: "Change Proposal Status to Closed",
					text: "Once an proposal is closed, the original proposal and all modifications will be closed and can no longer be edited. Are you sure you want to close it now?"
				},
				modifyForm: {
					header: "Modify Proposal",
					label: "Reason for modifying proposal",
				}
			},
		},
		subaward: {
			buttons: {
				modify: "Modify Subaward"
			},
			currentForm: "Currently Viewing Subaward Form: ",
			modal: {
				changeStatusActive: {
					headeing: "Change Subaward Status to Active",
					text: "Once a subaward is active a new modification can be added, but it cannot be edited. Are you sure you want to make it active now?"
				},
				changeStatusClosed: {
					headeing: "Change Subaward Status to Closed",
					text: "Once an subaward is closed, the original subaward and all modifications will be closed and can no longer be edited. Are you sure you want to close it now?"
				},
				modifyForm: {
					header: "Modify Subaward",
					label: "Reason for modifying subaward",
				}
			},
		}
	},
	s2sRecord: {
		headline: "Link to existing Proposals (S2S) Record",
		linkedHeader: "Proposals (S2S) Record",
		description: "Linking to an existing record will create a clickable navigation link between Sponsored Projects and Proposals(S2S). On creating a new Proposals (S2S) record, any of the following fields that are completed in Sponsored Projects will autofill into the new Proposals (S2S) record:",
		createNewS2SRecord: "Create New Proposal (S2S) Record",
		createNewLabel: "Create new Grants.gov proposal",
		unableLink: "Unable to link proposal. Please try again later.",
		unableUnlink: "Unable to unlink proposal. Please try again later.",
		unableCreateProposal: "Unable to create proposal due to invalid data. Please reach out to Cayuse support for assistance.",
		searchPlaceholder: "Search by proposal name...",
		noRecords: "No records have been selected yet.",
		noS2SProduct: "Proposals (S2S) is not provisioned on this tenant.",
		noAccess: "The ability to use this form object requires an S2S user role. Please work with an administrator to give you an applicable role if necessary.",
		serviceUnavailable: "The Proposals (S2S) service is unavailable or not yet configured.",
		errorGeneric: "An error occurred loading the Proposals (S2S) service.",
		notAuthorized: "The action is not authorized. Please contact an administrator to check your permissions.",
		contactAdminstrator: "Please contact an administrator if the issue persists.",
		partlyAccess: "You don’t have sufficient access to the linked S2S Proposal to see all data fields or unlink the proposal. Please work with an administrator to give you access to the applicable S2S Proposal if necessary.",
		noProposalID: "No Proposal ID found.",
		opportunitySearchLabel: "Proposals (S2S) Opportunity Search",
		opportunityPlaceholder: "Search by opportunity title or opportunity number",
		searchingMessage: "Loading...",
		successSaveMsg: "Proposals (S2S) record created",
	},
	humanEthicsStudySearch: {
		headline: "Human Ethics Study Search",
		title: "Title",
		primaryInvestigator: "PI",
		status: "Status",
		study: "Study",
		approvalDate: "Approval Date",
		expirationDate: "Expiration Date",
	},
	animalProtocolSearch: {
		headline: "Link to Animal Protocols",
		protocolNumber: "Protocol #",
		title: "Title",
		approvalDate: "Approval Date",
		expirationDate: "Expiration Date",
		primaryInvestigator: "PI",
		status: "Status",
		searchPlaceholder: "Type or select a search category..."
	},
	hazardSafetySearch: {
		headline: "Link to Hazard Safety",
		protocolNumber: "Protocol #",
		title: "Title",
		approvalDate: "Approval Date",
		expirationDate: "Expiration Date",
		primaryInvestigator: "PI",
		status: "Status",
		searchPlaceholder: "Type or select a search category..."
	},
	haploCostingIntegration: {
		headline: "Link to Costing Tool Records",
		costingID: "Costing ID",
		title: "Title",
		startDate: "Start Date",
		duration: "Duration",
		primaryInvestigator: "Lead PI",
		status: "Status",
		noData: "Costing Tool returned no records linked to this SP record. This can indicate that there are in fact no records linked to this SP record, or you do not have access to view the linked records. If you believe there are linked records, please work with an administrator to grant you the necessary roles within Costing Tool to gain access to those records.",
		infoText: "Costing Tool returns only the linked records that you have access to. If you believe there are additional linked records, please work with an administrator to grant you the necessary roles within Costing Tool to gain access to those records.",
		errorMessage: "You don’t have sufficient access to view all of the linked Costing Tool. Please work with an administrator to give you access to the applicable Costing Tool if necessary"
	},
	haploEthicsIntegration: {
		headline: "Link to Ethics Monitor Studies",
		studyID: "Study ID",
		title: "Title",
		approvalDate: "Approval Date",
		expirationDate: "Expiration Date",
		primaryInvestigator: "Lead PI",
		status: "Status",
		noData: "Ethics Monitor returned no records linked to this SP record. This can indicate that there are in fact no records linked to this SP record, or you do not have access to view the linked records. If you believe there are linked records, please work with an administrator to grant you the necessary roles within Ethics Monitor to gain access to those records.",
		infoText: "Ethics Monitor returns only the linked records that you have access to. If you believe there are additional linked records, please work with an administrator to grant you the necessary roles within Ethics Monitor to gain access to those records.",
		errorMessage: "You don’t have sufficient access to view all of the linked Ethics Monitor. Please work with an administrator to give you access to the applicable Ethics Monitor if necessary"
	},
	haploRepositoryIntegration: {
		headline: "Link to Repository Records",
		title: "Repository record Title",
		type: "Type",
		authors: "Authors",
		status: "Status",
		noData: "Repository returned no records linked to this SP record. This can indicate that there are in fact no records linked to this SP record, or you do not have access to view the linked records. If you believe there are linked records, please work with an administrator to grant you the necessary roles within Repository to gain access to those records.",
		infoText: "Repository returns only the linked records that you have access to. If you believe there are additional linked records, please work with an administrator to grant you the necessary roles within Repository to gain access to those records.",
		errorMessage: "You don’t have sufficient access to view all of the linked Repository. Please work with an administrator to give you access to the applicable Repository if necessary"
	},
	proposals: {
		accessibilityLabelProposalNumber: "Proposal Num. ",
		assignedToMeOnly: "See assigned to me only",
		filePrefix: "SP_Proposals",
		noResults: "No Saved Proposals",
		proposalSearchAriaLabel: "Search proposals",
		errors: {
			proposalFailedLoad: "Proposal information didn’t load successfully. Please refresh the page to try again.",
			ProposalsFailedLoad: "The proposals didn’t load successfully. Please refresh the page to try again.",
			proposalSummaryNotFound: "Proposal values could not be loaded. Please reload the page if needed, or continue with other tasks.",
			tilesFailedLoad: "Information for the summary tiles didn’t load successfully. Please refresh the page to try again."
		},
		routing: {
			columnHeaders: {
				team: "Team",
				members: "Members",
				status: "Status",
				date: "Date",
				comment: "Comment"
			},
			commentModal: {
				titleWithCreator: "Routing Comment from",
				titleWithoutCreator: "Routing Comment"
			},
			decisions: {
				approved: "Approved",
				declined: "Declined",
				pending: "Pending",
				notCompleted: "Not Completed",
				emptyStatus: "Not Yet Active",
				skipped: "Skipped",
			},
			certification: {
				certified: "Certified",
				pending: "Pending",
				notCompleted: "Not Completed",
				emptyStatus: "Not Yet Active",
				skipped: "Skipped",
			},
			errors: {
				noRouting: "This proposal has not yet been routed for review. Information about the review process will be displayed once routing has begun.",
				unableToLoad: "Unable to load routing information",
				routeReviewFailed: "Reviews could not be routed. Please try again.",
				unknownTeam: "Unknown, team cannot be found",
			},
			sectionHeading: "Routing for Review",
			viewComment: "view",
		},
		setView: "Set View",
		startNewProposal: {
			cancel: "Cancel",
			startNew: "Start New Proposal",
			addNew: "Add A Proposal",
			createNew: "Create New Proposal",
			newLabel: "Enter a title for your project:",
			newBlurb: "This proposal <i>is not</i> related to any existing proposals or awards (Create New Project)",
			newPlaceholder: "New project title",
			searchLabel: "Click to search by Project Number or Project Title",
			searchBlurb: "This proposal <i>is</i> related to existing proposals or awards (Add Proposal to Project)",
			confirmNewProject: "Create New Project",
			confirmNewProposal: "Add New Proposal to Project",
			errors: {
				notAuthorized: "The action is not authorized. Please contact an administrator to check your permissions.",
				noActionSelected: "Please select where to create a new proposal",
				noProjectSelected: "Please select a project",
				noProjectTitle: "Please enter a project title",
				projectTitleLengthValidation: "Project title must be less than 256 characters",
				userNotSetUp: "User is not set up to create project/proposal. Please ask Cayuse system administrator for assistance.",
				createProposalFailed: "The new project and proposal weren’t saved successfully. Please try creating them again.",
				createProjectFailed: "The new proposal wasn’t saved successfully. Please try creating a new proposal in the project again."
			},
			successMessages: {
				createProposal: "New proposal created successfully!",
				createProposalAndProject: "New project and proposal created successfully!"
			}
		},
		summary: {
			completeReview: {
				buttonLabel: "Complete Review",
				completeAll: 'Complete all Reviews',
				cancelLabel: "Cancel",
				decisions: {
					approved: "Approve",
					declined: "Return to In Development"
				},
				errors: {
					noComment: "A comment is required",
					noDecision: "A review decision is required",
					unableToSave: "Unable to complete the review",
					reviewNotCompleted: "The review could not be completed. Please click save again.",
					statusNotChanged: "The status could not be changed. Please try again."
				},
				fields: {
					reviewDecision: "Review Decision",
					reviewDecisionPlaceholder: "Review Decision",
					comment: "Comment",
					commentPlaceholder: "Please add a comment."
				},
				modalTitle: "Complete Review",
				modalTitleSeparator: "for",
				modalTitleMultipleRules: "Multiple Rules",
				saveLabel: "Save",
				taskTypeHeaderDisplays: {
					UNIT: "Unit",
					TEAM: "Team",
					RESEARCH: "Research Team"
				},
			},
			certification: {
				buttonLabel: "Certify Proposal",
				cancelLabel: "Cancel",
				errors: {
					notConfirmed: "Please check the Confirm checkbox",

				},
				fields: {
					confirmPlaceholder: "Confirm my Certification",
					comment: "Comment",
					commentPlaceholder: "Please add a comment."
				},
				modalTitle: "Confirm Certification",
				modalTitleSeparator: "for",
				saveLabel: "Certify",
			},
			myActions: "My Actions",
			proposalSummary: "Proposal Summary",
			statuses: {
				inDevelopment: "In Development"
			},
			editCommentLabel: "Comment",
			editCommentPlaceholder: "Please add a comment.",
			resolutionLabel: "Resolution",
			routeForReview: "Route for Review",
			saveCommentLabel: "Save",
			selectResolutionPlaceholder: "Select ...",
			selectResolutionLabel: "Please select a resolution and add a comment."
		},
		coiComponent: {
			headline: "Conflict of Interest",
			title: "Title",
			primaryInvestigator: "PI",
			status: "Status"

		},
		history: {
			currentlyAssigned: "Currently Assigned",
			currentlyAssignedNone: "None",
			editAssignmentLabel: "edit",
			unknownUser: "Unknown User",
			unknownRole: "Unknown Role",
			columnHeaders: {
				action: "Action",
				name: "Name",
				date: "Date",
				comment: "Comment"
			},
			reviewCommentLabel: "view",
			cancelCommentLabel: "Cancel",
			assignedPrefix: "Proposal assigned to ",
			unassignedPrefix: "Proposal unassigned from ",
			commentModal: {
				title: "Status Comment"
			}
		},
		attachments: {
			attachmentTypeSelector: {
				label: "Attachment Type",
				placeholder: "Select..."
			},
			multiFileUpload: {
				button: "Upload File",
				textDropFiles: "Drop files here to upload",
				textOr: "or",
			},
			columnHeaders: {
				attachmentName: "Attachment",
				attachmentType: "Attachment Type",
				date: "Date",
				note: "Note",
				updatedBy: "Last Updated By"
			},
			confirmationModal: {
				title: "Delete Attachment"
			},
			instructions: {
				title: "Add Attachment",
				text: 'To add an attachment, first select the type of attachment and then drop the file into the box or click "Upload file." Attachments with filetype .exe will not be accepted'
			},
			uploadComponent: {
				label: "Drop files here to upload",
				button: "Upload File"
			},
			errors: {
				unableToSave: "Unable to complete the download"
			}
		}
	},
	proposalDetails: { /* todo: nest other detail-tab entries here */
		breadcrumbRoot: "My Active Projects",
		proposalFormTab: "ProposalForm",
		proposalHistoryTab: "Proposal History Tab",
		proposalNotesTab: "Notes",
		routingTab: "Routing",
		tabLabels: {
			access: "Access",
			form: "Proposal Form",
			routing: "Routing",
			history: "History",
			notes: "Notes",
			attachments: "Attachments",
			relatedRecords: "Related Records",
			adminOnly: "Admin Only"
		},
		adminTeam: {
			buttonLabels: {
				add: "Add Person",
				cancel: "Cancel",
				edit: "Edit",
				save: "Save"
			},
			columnHeaders: {
				edit: "Edit",
				email: "Email",
				person: "Person",
				view: "View"
			},
			instructions: "Manage  who can view or edit the proposal.",
			title: "Proposal Access",
			errors: {
				noTeamMembers: "No team members have been assigned to this proposal.",
				unableToSave: "There was an error and changes to the team were not saved. Please try saving the team again."
			}
		}
	},
	simplifiedBuilder: {
		section: {
			header: {
				showSettings: "Show additional question settings",
				hideSettings: "Hide additional question settings",
			},
		},
		components: {
			Question: {
				Footer: {
					key: "Key",
					label: "Label",
					showMoreQuestionSettings: "Show more Question Settings",
					hideMoreQuestionSettings: "Hide more Question Settings",
					questionType: "Question Type",
					required: "Required"
				},
			},
			RuleGroup: {
				and: "AND",
			},
			RuleModal: {
				optionsHeader: "Options",
				questionsHeader: "Questions",
				sectionsHeader: "Sections",
				title: "Select a Display Rule",
				displayTitle: "Select a Display Rule",
				ignoreTitle: "Select an Ignore Rule",
			},
			RulesTab: {
				common: {
					addGroup: "Add Group",
					addQuestionAndAnswer: "Add Question and Answer",
					expression: "Expression: ",
					or: "OR"
				},
				visible: {
					topText: "This question will display in the form if:",
				},
				ignore: {
					topText: "This question will be ignored if:",
				},
				enable: {
					topText: "This question will enable in the form if:",
				},
			},
			SettingsTab: {
				description: "Description",
				descriptionExplanation: " - displays below the Question Name",
				descriptionLabel: "Add a question description...",
				tooltip: "Tooltip",
				tooltipExplanation: " - this will display in a pop-up next to question",
				tooltipLabel: "Add tooltip text..."
			},
			TabList: {
				formSections: "Form Sections"
			},
			manageSectionsModal: {
				title: "Manage Sections",
				openModalButton: "Open manage sections modal",
				cancelButton: "Cancel",
				saveButton: "Save",
			},
			manageSectionsModalSectionCard: {
				inputLabel: "Section name",
				removeSectionButton: "Delete section",
				addSectionButton: "Add section",
				confirmModal: {
					title: "Deleting",
					message: "Section, and all its questions and display rules, will be deleted permanently. Are you sure you want to delete it?",
					cancelButtonLabel: "Cancel",
					confirmButtonLabel: "Delete section"
				},
			},
			researchTeam: {
				externalResearchersTitle: "Allow External Researchers",
				externalResearchersDescription: "Allow External Researchers",
				allowNewPerson: "Allow creation of new external researchers",
				creditFieldTitle: "Display Credit Field",
				creditFieldDescription: "Display Credit Field",
				creditFieldRequiredTitle: "Credit Field required",
				creditFieldRequiredDescription: "Credit Field required",
				sponsoredEffortTitle: "Display Sponsored Effort",
				sponsoredEffortDescription: "Display Sponsored Effort",
				sponsoredEffortRequiredTitle: "Sponsored Effort required",
				sponsoredEffortRequiredDescription: "Sponsored Effort required",
				costShareEffortTitle: "Display Cost Share Effort",
				costShareEffortDescription: "Display Cost Share Effort",
				costShareEffortRequiredTitle: "Cost Share Effort required",
				costShareEffortRequiredDescription: "Cost Share Effort required",
				defaultEffortFormatTitle: "Default effort format",
				defaultEffortFormatDescription: "Default effort format"
			},
			upload: {
				allowDeletion: "Allow file deletions",
			},
			classificationCodeSettings: {
				limitToFourDigits: "Limit to four digit codes (Division and Group only)",
				excludeSubcategories: "Exclude subcategories from options",
				includePercentage: "Include Percentage (Percentages are required to equal 100%)",
				minNumberOfCodes: "Minimum Number of Codes",
				minNumberOfCodesExplanation: " - this many codes are the minimum that will appear on the form",
				maxNumberOfCodes: "Maximum Number of Codes",
				maxNumberOfCodesExplanation: " - up to this many codes may be added to the form",
				errors: {
					wrongMinValue: "Minimum number must be less than the maximum number",
					wrongMaxValue: "Maximum number must be larger than the minimum number",
					wrongRangeByCodeType: {
						FOR: "This number must be between 1 - 99",
						SEO: "This number must be between 1 - 99",
						TOA: "This number must be between 1 - 4",
						HERDC: "This number must be between 1 - 26",
					},
				},
			},
			fundingProgram: {
				label: "Funding Program",
				inputPlaceholder: "Select Funding Program",
				tableColumns: [ "Program name", "Active?", "Description" ],
				emptyTable: "No Funding Program selected",
				addItemButton: "Add Funding Program",
			},
			fundingScheme: {
				label: "Funding Scheme",
				inputPlaceholder: "Select Funding Scheme",
				tableColumns: [ "Scheme name", "Active?", "Description" ],
				emptyTable: "No Funding Scheme selected",
				addItemButton: "Add Funding Scheme",
			},
		},
	},
	classificationCodes: {
		common: {
			percentOfResearch: "Percent of Research",
			remove: "Remove",
			required: "All fields are required",
			searchPlaceholder: "Start typing to search...",
		},
		errorMessages: {
			maximumReached: "The maximum number of fields has been reached",
			totalPercentageNotRequired: "Total percent must equal 0% or 100%",
			totalPercentageRequired: "Total percent must equal 100%",
			empty: "Field must not be empty"
		},
		for: {
			searchLabel: "Field of Research",
			addLabel: "Add Field of Research",
		},
		seo: {
			searchLabel: "Socio-economic Objective",
			addLabel: "Add Socio-economic Objective",
		},
		toa: {
			searchLabel: "Type of Activity",
			addLabel: "Add Type of Activity",
		},
		herdc: {
			searchLabel: "Higher Education Research Data Collection Classification",
			addLabel: "Add HERDC Classification",
		}
	},
	fundingProgram: {
		form: {
			addFundingProgramButton: "Add Funding Program",
			programsBlock: {
				inputLabel: "Funding Program",
				inputPlaceholder: "Select Funding Program",
				tableColumns: [ "Program name", "Active?", "Description" ],
				emptyTable: "No Funding Program selected",
			},
			addRoundButton: "Add Round",
			removeFundingProgramButton: "Remove Funding Program",
			roundsBlock: {
				inputLabel: "Round",
				inputPlaceholder: "Select Round",
				tableColumns: [ "Round", "Year", "Internal Closing Date", "External Closing Date", "Active?" ],
				emptyTable: "No Round selected",
				removeRoundButton: "Remove Round",
			},
			errors: {
				emptyField: "Field must not be empty",
				emptyRound: "Round must not be empty",
			},
		},
	},
	fundingScheme: {
		form: {
			addFundingProgramButton: "Add Funding Scheme",
			programsBlock: {
				inputLabel: "Funding Scheme",
				inputPlaceholder: "Select Funding Scheme",
				tableColumns: [ "Scheme name", "Active?", "Description" ],
				emptyTable: "No Funding Scheme selected",
			},
			addRoundButton: "Add Round",
			removeFundingProgramButton: "Remove Funding Scheme",
			roundsBlock: {
				inputLabel: "Round",
				inputPlaceholder: "Select Round",
				tableColumns: [ "Round", "Year", "Internal Closing Date", "External Closing Date", "Active?" ],
				emptyTable: "No Round selected",
				removeRoundButton: "Remove Round",
			},
			errors: {
				emptyField: "Field must not be empty",
				emptyRound: "Round must not be empty",
			},
		},
	},
	budgetBuilder: { /* todo: nest other detail-tab entries here */
		components: {
			ConfirmOverwriteModal: {
				cancel: "Cancel",
				continue: "Continue",
				message: "Warning, this copy action will replace the current content of the period. Are you sure you want to continue?",
				title: "Confirm"
			},
			AddUnnamedMember: {
				academicAppointmentMonths: "Academic Appointment Months",
				academicFringeRate: "Academic Fringe Rate",
				academicSalary: "Academic Salary",
				calendarAppointmentMonths: "Calendar Appointment Months",
				calendarFringeRate: "Calendar Fringe Rate",
				calendarSalary: "Calendar Salary",
				internalAssociation: "Internal Association",
				role: "Role",
				summerAppointmentMonths: "Summer Appointment Months",
				summerFringeRate: "Summer Fringe Rate",
				summerSalary: "Summer Salary",
			},
			EffortInput: {
				numberOutOfRange: "Please enter an amount between 1% and 100%"
			},
			LineItemsList: {
				header: "Line Items",
				lineItem: "Line Item",
				directCost: "Direct Cost",
				includeFA: "Include F&A",
				faRate: "F&A Rate",
				faCost: "F&A Cost",
				periodTotalCost: "Period Total Cost",
				lineItemsTotal: "Line Items Total"
			},
			OrgFinderInput: {
				label: "Organization"
			},
			PeriodDropdown: {
				label: "Details for period",
				periodOf: "Period {periodNumber} of {numberOfPeriods}"
			},
			PersonMonthsInput: {
				numberOutOfRange: "Please enter an amount between 0.1 and 12.0"
			},
			RateTypeTable: {
				noRateSelected: "No rate type has been selected",
				type: "Type"
			},
			ResearchTeamList: {
				name: "Name",
				role: "Role",
				internalAssociation: "Internal Association",
				baseSalary: "Base Salary",
				apptMonths: "Appt Months",
				effort: "Effort",
				personMonths: "Person Months",
				requestedSalary: "Requested Salary",
				fringeRate: "Fringe Rate",
				requestedFringe: "Requested Fringe",
				periodTotal: "Period Total",
			},
			AddMemberModal: {
				add: "Add",
				modalHeader: "Add Person",
				close: "Close",
				subtitle: "Add a person to be named later (i.e. a postdoc or lab tech who is not yet hired)"
			},
			toggle: {
				activeText: "Active",
				inactiveText: "Inactive",
				tip: "At least one resolution must be active"
			},
			UnitFinder: {
				label: "Unit",
			}
		},
		buttonLabels: {
			addPerson: "Add Person",
			cancel: "Cancel",
			edit: "Edit",
			save: "Save"
		},
		breadcrumbRoot: "My Active Projects",
		proposalFormTab: "ProposalForm",
		proposalHistoryTab: "Proposal History Tab",
		proposalNotesTab: "Notes",
		routingTab: "Routing",
		tabLabels: {
			attachments: "Overview",
			routing: "Sponsor Costs",
			history: "Cost Share",
			notes: "Versions",
			form: "Setup"
		},
		addCategory: "Add New Category",
		adminTeam: {
			buttonLabels: {
				add: "Add Person",
				cancel: "Cancel",
				edit: "Edit",
				save: "Save"
			},
			columnHeaders: {
				edit: "Edit",
				email: "Email",
				person: "Person",
				view: "View"
			},
			instructions: "Manage  who can view or edit the proposal.",
			title: "Proposal Access",
			errors: {
				noTeamMembers: "No team members have been assigned to this proposal.",
				unableToSave: "There was an error and changes to the team were not saved. Please try saving the team again."
			}
		}
	},
	projectDetails: {
		breadcrumbRoot: "Project Dashboard",
		error: "The project data couldn't be loaded. Please try again."
	},
	projects: {
		noResults: "No Saved Projects",
		projectsSearchAriaLabel: "Search projects",
		summary: {
			projectInformation: "Project Information",
			title: "Title:",
			editDescription: "Any changes made will affect all records within the project",
			leaveEditPrompt: "Changes you made may not be saved",
			notifications: {
				emptyTitle: "Title should not be empty.",
				projectTitleLengthValidation: "Project title must be less than 256 characters",
				updateSuccess: "Your changes have been saved. Updates may take several minutes to display."
			},

		},
		tableHeadings: { // todo: do these need to be here or will translated field labels be available elsewhere?
			projectTitle: "Project Title",
			projectNumber: "Project #",
			status: "Status"
		},
		errors: {
			projectFailedLoad: "Project information didn’t load successfully. Please refresh the page to try again.",
			projectsFailedLoad: "The projects didn’t load successfully. Please refresh the page to try again.",
			tilesFailedLoad: "Information for the summary tiles didn’t load successfully. Please refresh the page to try again."
		},
		history: {
			currentlyAssigned: "Currently Assigned",
			currentlyAssignedNone: "None",
			editAssignmentLabel: "edit",
			unknownUser: "Unknown User",
			unknownRole: "Unknown Role",
			columnHeaders: {
				action: "Action",
				name: "Name",
				date: "Date",
				comment: "Comment"
			},
			reviewCommentLabel: "view",
			cancelCommentLabel: "Cancel",
			assignedPrefix: "Project assigned to ",
			unassignedPrefix: "Project unassigned from ",
			commentModal: {
				title: "Status Comment"
			}
		}
	},
	pagingControls: {
		ariaNextItem: "Next Item",
		ariaPreviousItem: "Previous Item",
		showing: "Showing",
		xOfYSeparator: "of",
		items: "items",
		goToPage: "Go to page",
		currentlyShowing: "Currently showing",
		perPage: "per page"
	},
	navBar: {
		attachmentTypes: "Attachment Types",
		forms: "Forms",
		manageCertificationText: "Manage Certification Text",
		manageRTRoles: "Manage Research Team Roles",
		manageResolutions: "Manage Resolutions",
		manageModifications: "Manage Modifications",
		more: "More",
		navBarHeader: "Site Navigation",
		projectAttachmentTypes: "Project Attachment Types",
		projects: "Projects",
		proposals: "Proposals",
		reporting: "Reporting",
		proposalReport: "Generate Proposal Report",
		awardReport: "Generate Award Report",
		subawardReport: "Generate Subaward Report",
		subawards: "Subawards"
	},
	main: {
		landmarkAriaLabel: "Main content"
	},
	resolutions: {
		components: {
			toggle: {
				activeText: "Active",
				inactiveText: "Inactive",
				tip: "At least one resolution must be active"
			}
		},
		proposal: {
			resolutionGuidance: "Resolutions help track why a proposal was closed. They may be selected by administrators when moving a proposal to the Closed state.",
			resolutionContentHeader: "Closed Proposal Resolutions"
		},
		award: {
			resolutionGuidance: "Resolutions help track why an award was closed. They may be selected by administrators when moving an award to the Closed state.",
			resolutionContentHeader: "Closed Award Resolutions"
		},
		subaward: {
			resolutionGuidance: "Resolutions help track why a subaward was closed. They may be selected by administrators when moving a subaward to the Closed state.",
			resolutionContentHeader: "Closed Subaward Resolutions"
		},
		project: {
			resolutionGuidance: "Resolutions help track why a project was closed. They may be selected by administrators when moving a project to the Closed state.",
			resolutionContentHeader: "Closed Project Resolutions"
		},
		manageResolutions: "Manage Resolutions",
		titleRowHeader: "Resolution Title",
		activeRowHeader: "Active",
		addResolution: "Add New Resolution",
		modalHeader: "Create a new resolution.",
		modalContent: `Enter a title for your new resolution and click "Save", your new resolution will be added to the list and set to active.`,
		modalGuidance: `Click "cancel" to discard changes and return to list.`,
		inputPlaceholder: `Resolution...`,
		inputAriaLabel: "Resolution",
		errorNoTitle: "Title must not be empty or all whitespace.",
		errorDuplicateTitle: "Title must be unique.",
		cancel: "Cancel",
		saveResolution: "Save"
	},
	"modification-types": {
		components: {
			toggle: {
				activeText: "Active",
				inactiveText: "Inactive",
				tip: "At least one modification must be active"
			}
		},
		award: {
			modificationContentHeader: "Award Modification Reasons"
		},
		subaward: {
			modificationContentHeader: "Subaward Modification Reasons"
		},
		manageModifications: "Manage Modifications",
		titleRowHeader: "Reason Title",
		activeRowHeader: "Active Status",
		addNewReason: "Add New Reason",
		modalHeader: "Create a new modification.",
		modalContent: `Enter a title for your new modification and click "Save", your new modification will be added to the list and set to active.`,
		modalGuidance: `Click "cancel" to discard changes and return to list.`,
		inputPlaceholder: `Modification...`,
		inputAriaLabel: "Modification",
		errorNoTitle: "Title must not be empty or all whitespace.",
		errorDuplicateTitle: "Title must be unique.",
		cancel: "Cancel",
		saveModification: "Save"
	},
	ruleBuilder: {
		breadcrumbs: {
			root: "Forms",
			rules: "Rules"
		},
		addCondition: "Add Condition",
		backButtonLabel: "Back",
		cancelModal: "Cancel",
		cancelNewRule: "Cancel",
		confirmCancel: "There are unsaved changes. Are you sure you want to discard your changes?",
		confirmCancelTitle: "Unsaved Rule",
		conditionIsAnsweredDisplay: "answered",
		conditionSeparator: "is",
		heading: "Rule Builder",
		noOptionsApply: "No options apply to this question.",   // non-picklist field
		selectFundingProgram: "Select a Funding Program...",
		selectFundingScheme: "Select a Funding Scheme...",
		selectExternalOrganization: "Select an External Organization...",
		selectPerson: "Select a Person...",
		selectUnit: "Select a Unit...",
		selectClassificationCode: "Select a Code...",
		noOptionsAvailable: "No options have been supplied for this question.", // picklist without options
		noRulesMessage: "No rules have been created",
		saveListOrder: "Save List Order",
		rulesButtonGroupHeading: "Rules",
		saveNewRule: "Save",
		selectTeamPlaceholder: "Select Team",
		tableHeading: "Review and Notification Rules",
		unsavedChangesTitle: "Unsaved Changes",
		unsavedOrderChanges: "There are unsaved changes to the review order. Are you sure you want to lose them?",
		updateModal: "Update",
		actionBuilder: {
			actionLabels: {
				awardForm: {
					[RULE_TYPES.AD_HOC_NOTIFICATION]: "Send <strong>Notification</strong> to all members of team",
					[RULE_TYPES.AD_HOC_REVIEW]: "Require <strong>Review</strong> from one member of team ",
					[RULE_TYPES.UNIT_REVIEW]: "Require <strong>Review</strong> from one "
					+ "<strong>SP Award Reviewer</strong> in this <strong>Unit</strong>",
					[`${RULE_TYPES.UNIT_REVIEW}_${RULE_SUBTYPES.SPECIFIC_UNIT}`]: "Require <strong>Review</strong> from one "
					+ "<strong>SP Award Reviewer</strong> in ",
					award: "Require <strong>Review</strong> from one "
						+ "<strong>SP Award Reviewer</strong> in this <strong>Unit</strong>",
					[RULE_TYPES.RT_CERTIFICATION]: "Require <strong>Certification</strong> from "
					+ "<strong>RT Member</strong>",
					[RULE_TYPES.RT_REVIEW]: "Require <strong>Review</strong> from one <strong>SP Award Reviewer</strong>"
					+ " in <strong>RT Member's Selected Internal Association</strong>",
					[RULE_TYPES.DISCLOSURE]: "Require <strong>Outside Interests Disclosure</strong	> from <strong>RT Member</strong>",
					[RULE_SUBTYPES.UNIT]: "Send <strong>Notification</strong> to all <strong>SP Award Reviewers</strong> in this <strong>Unit</strong>",
					[RULE_SUBTYPES.SPECIFIC_UNIT]: "Send <strong>Notification</strong> to all <strong>SP Award Reviewers</strong> in",
					[RULE_SUBTYPES.RT]: "Send <strong>Notification</strong> to all <strong>SP Award Reviewers</strong> in the <strong>RT Member's Selected Internal Association</strong>",
					[RULE_SUBTYPES.RT_MEMBERS]: "Send <strong>Notification</strong> to all members of the <strong>Research Team</strong>",
				},
				default: {
					[RULE_TYPES.AD_HOC_NOTIFICATION]: "Send <strong>Notification</strong> to all members of team",
					[RULE_TYPES.AD_HOC_REVIEW]: "Require <strong>Review</strong> from one member of team ",
					[RULE_TYPES.UNIT_REVIEW]: "Require <strong>Review</strong> from one "
					+ "<strong>SP Form Reviewer</strong> in this <strong>Unit</strong>",
					[`${RULE_TYPES.UNIT_REVIEW}_${RULE_SUBTYPES.SPECIFIC_UNIT}`]: "Require <strong>Review</strong> from one "
					+ "<strong>SP Form Reviewer</strong> in ",
					award: "Require <strong>Review</strong> from one "
						+ "<strong>SP Form Reviewer</strong> in this <strong>Unit</strong>",
					[RULE_TYPES.RT_CERTIFICATION]: "Require <strong>Certification</strong> from "
					+ "<strong>RT Member</strong>",
					[RULE_TYPES.RT_REVIEW]: "Require <strong>Review</strong> from one <strong>SP Form Reviewer</strong>"
					+ " in <strong>RT Member's Selected Internal Association</strong>",
					[RULE_SUBTYPES.UNIT]: "Send <strong>Notification</strong> to all <strong>SP Form Reviewers</strong> in this <strong>Unit</strong>",
					[RULE_SUBTYPES.SPECIFIC_UNIT]: "Send <strong>Notification</strong> to all <strong>SP Form Reviewers</strong> in",
					[RULE_SUBTYPES.RT]: "Send <strong>Notification</strong> to all <strong>SP Form Reviewers</strong> in the <strong>RT Member's Selected Internal Association</strong>",
					[RULE_SUBTYPES.RT_MEMBERS]: "Send <strong>Notification</strong> to all members of the <strong>Research Team</strong>",
				},
				proposalForm: {
					[RULE_TYPES.AD_HOC_NOTIFICATION]: "Send <strong>Notification</strong> to all members of team",
					[RULE_TYPES.AD_HOC_REVIEW]: "Require <strong>Review</strong> from one member of team ",
					[RULE_TYPES.UNIT_REVIEW]: "Require <strong>Review</strong> from one "
					+ "<strong>SP Proposal Reviewer</strong> in this <strong>Unit</strong>",
					[`${RULE_TYPES.UNIT_REVIEW}_${RULE_SUBTYPES.SPECIFIC_UNIT}`]: "Require <strong>Review</strong> from one "
					+ "<strong>SP Proposal Reviewer</strong> in ",
					award: "Require <strong>Review</strong> from one "
						+ "<strong>SP Proposal Reviewer</strong> in this <strong>Unit</strong>",
					[RULE_TYPES.RT_CERTIFICATION]: "Require <strong>Certification</strong> from "
					+ "<strong>RT Member</strong>",
					[RULE_TYPES.RT_REVIEW]: "Require <strong>Review</strong> from one <strong>SP Proposal Reviewer</strong>"
					+ " in <strong>RT Member's Selected Internal Association</strong>",
					[RULE_TYPES.DISCLOSURE]: "Require <strong>Outside Interests Disclosure</strong> from <strong>RT Member</strong>",
					[RULE_TYPES.INFOREADY_REVIEW]: "Require <strong>Review</strong> from one member of InfoReady team ",
					[RULE_SUBTYPES.UNIT]: "Send <strong>Notification</strong> to all <strong>SP Proposal Reviewers</strong> in this <strong>Unit</strong>",
					[RULE_SUBTYPES.SPECIFIC_UNIT]: "Send <strong>Notification</strong> to all <strong>SP Proposal Reviewers</strong> in",
					[RULE_SUBTYPES.RT]: "Send <strong>Notification</strong> to all <strong>SP Proposal Reviewers</strong> in the <strong>RT Member's Selected Internal Association</strong>",
					[RULE_SUBTYPES.RT_MEMBERS]: "Send <strong>Notification</strong> to all members of the <strong>Research Team</strong>",
				},
				actionOptions: {
					review: "Review",
					notification: "Notification",
					certification: "Certification",
					integration: "Integration",

				}
			},
			action: "Action",
			missingAction: "Unable to display the rule action",
			requireCertification: "Require Certification from RT Member",
			reviewLabel: "Choose a review audience:",
			notificationLabel: "Choose a notification audience:",
			unit: "Unit",
			team: "Team",
			unitFinder: "Unit from Unit Finder Object",
			seletedUnit: "Select a Unit",
			researchTeam: "Research Team Member’s Internal Association",
			seletedTeam: "Select Team",
			integrationLabel: "Choose an integration:",
			disclosure: "Outside Interests",
			infoReady: "InfoReady",
			additionalReview: "Require Additional Review",
			researchTeamNotifications: "Research Team",
			teamNotifications: "Team",
		},
		conditionBuilder: {
			certificationReview: {
				conditionPrefix: "If RT role is"
			},
			missingCondition: "Unable to display the rule condition",
			researchTeamReview: {
				conditionPrefix: "If RT role is"
			},
			outsideInterestDisclosure: {
				conditionPrefix: "If role is"
			},
			editCondition: "Edit Condition",
			editAction: "Edit Action",
			addGroup: "Add Group",
			groupLabel: "Group",
			addLogic: "Add Logic",
			andLabel: "AND",
			orLabel: "OR",
			editAlertDialogTitle: "Edit Condition?",
			editAlertDialogMessage: "Editing the Condition will require you to re-select an action",
			editAlertDialogConfirm: "Edit Condition"
		},
		actionButtonLabels: {
			teamNotification: "Team Notification Rule",
			teamReview: "Team Review Rule",
			unitReview: "Unit Review Rule",
			researchTeamCertification: "Certification Rule",
			researchTeamReview: "Research Team Review Rule",
			inforeadyReview: "InfoReady Review Rule",
			disclosure: "Outside Interests Disclosure Rule"
		},
		columnHeaders: {
			reviewOrder: "Review Order",
			condition: "Condition",
			action: "Action",
			delete: ""
		},
		errors: {
			isAddingRule: "Save or cancel the new rule being created before reordering",
			noOrderChanges: "No unsaved review order indices",
			noRulesToOrder: "No rules have been created yet",
			noRuleOrderIndex: "Add a number between 1 - 99 to save the rule",
			notAllRulesOrderIndexes: "Add a number between 1 - 99 to all rules to reorder them",
			noTeamSelected: "Select a Team before saving",
			noConditionSelected: "Add a condition before saving",
			noResearchTeamRoleSelected: "Select a Research Team Role before saving",
			noOutsideInterestRoleSelected: "Select an Outside Interests Role before saving",
			unknownTeam: "Unknown, team cannot be found",
		},
	},
	searchBar: {
		searchPlaceholder: "Start typing to search"
	},
	summaryBudget: {
		title: "Budget Summary",
		inputTypeQuestion: "How would you like to show your budget?",
		buttons: {
			builder: "Display summary from Budget Builder",
			cancel: "Cancel",
			confirm: "Confirm",
			edit: "Edit",
			editAriaLabel: "Edit Budget Information",
			manual: "Manually enter budget information",
			save: "Save",
			upload: "Upload a spreadsheet"
		},
		confirmModal: {
			message: 'Switching input types will delete remove the uploaded file. Press "Cancel" to continue using the upload component, press "Confirm" to switch input types. Make sure you have a copy of the file before confirming',
			title: "Are you sure you want to change the input type?"
		},
		inputTypes: {
			builder: "builder",
			manual: "manual",
			upload: "upload"
		},
		totalCostRowNames: {
			costShare: "Total Cost Share",
			directCost: "Total Direct Costs",
			projectCost: "Total Project Cost",
			sponsorCost: "Total Sponsor Costs"
		}
	},
	tasks: {
		actionButtonLabels: {
			back: "Back",
			cancel: "Cancel",
			assignAndSend: "Assign And Send",
			saveChanges: "Save Changes"
		},
		assignTo: "Assign To",
		assignToPlaceholder: "Select a Person...",
		closed: "Closed",
		due: "Due",
		inactiveUser: "Selected user is inactive.",
		invalidUrl: "Please include http or https in the URL.",
		newTask: "New Task",
		newMilestone: "New Milestone",
		linkToMilestone: "Link To Milestone",
		createNewDropdown: {
			label: "Create New",
			taskOption: "Task",
			milestoneOption: "Milestone",
		},
		notifications: {
			taskSent: "Your new task has been assigned and sent.",
			creationError: "Task could not be created.",
			updatingError: "Task could not be updated.",
		},
		open: "Open",
		task: "Task",
		taskStatus: "Task Status",
		url: "URL",
		urlPlaceholder: "Add url...",
		unsavedChangesAlertDialog: {
			title: "Leave Page?",
			description: "Changes you made will not be saved.",
			confirmText: "Leave Page",
		},
		noResults: "No results to display.",
	},
	tasksDrawer: {
		heading: "My Tasks",
		noTasks: "No outstanding tasks",
		openButtonLabel: "My Tasks",
		overTaskLimitLabel: "15+",
		tableColumns: [
			"Task ID",
			"Task",
			"For",
		],
	},
	budgetSettings: {
		components: {
			toggle: {
				activeText: "Active",
				inactiveText: "Inactive",
				tip: ""
			}
		},
		actions: {
			edit: "Edit",
			save: "Save",
			cancel: "Cancel",
		},
		budgetSettingsTitle: "Budget Settings",
		subawardCostsCapAmount: "Some budgets only allows indirect costs on the first portion of passthrough to Subawardees. Set the cap amount here.",
		sponserCostContentHeader: "Sponsor Cost Categories and Line Items",
		budgetSettingsContentHeader: "Subaward F&A Costs Cap Amount",
		budgetSettingsCategoryContentHeader: "Budget Categories",
		lineItemsContentHeader1: "The line items in the sponsor costs budget tab are organized into categories. Categories available on first setup, may not be re-named. Other categories, and line items for all categories, maybe added and edited to match your institution’s workflow.",
		lineItemsContentHeader2: "Categories or line items that are not in use by any budgets may be deleted. Ones that are in use may be archived, to remove them from the budget template going forward.",
		nameColHeader: "Name",
		objectCodeColHeader: "Object Code",
		statusColHeader: "Status",
		activeColHeader: "Active",
		titleRowHeader: "Name",
		overviewHeaderTitle: "Summary of All Budget Items and Periods",
		addAttachmentType: "Add New Attachment Type",
		modalHeader: "Create a new attachment type.",
		modalContent: `Enter a title for your new attachment type and click "Save", your new attachment type will be added to the list and set to active.`,
		modalGuidance: `Click "cancel" to discard changes and return to list.`,
		inputPlaceholder: `Attachment Type...`,
		errorNoTitle: "Title must not be empty or all whitespace.",
		errorDuplicateTitle: "Title must be unique.",
		cancel: "Cancel",
		saveAttachment: "Save"
	},
	categories: {
		components: {
			toggle: {
				activeText: "Active",
				inactiveText: "Inactive",
				tip: ""
			}
		},
		proposal: {
			costCategoryText1: "The line items in the sponsor costs budget tab are organized into categories. Categories available on first setup, may not be re-named. Other categories, and line items for all categories, may be added and edited to match your institution’s workflow.",
			costCategoryText2: "Categories or line items that are not in use by any budgets may be deleted. Ones that are in use may be archived, to remove them from the budget template going forward.",
			costCategoryHeader: "Sponsor Cost Categories and Line Items"
		},
		award: {
			resolutionGuidance: "Resolutions help track why an award was closed. They may be selected by administrators when moving an award to the Closed state.",
			resolutionContentHeader: "Closed Award Resolutions"
		},
		tabLabels: {
			attachments: "Overview",
			routing: "Sponsor Costs",
			history: "Cost Share",
			notes: "Versions",
			form: "Setup"
		},
		objectCodeColHeader: "Object Code",
		statusColHeader: "Status",
		activeColHeader: "Active",
		manageResolutions: "Manage Categories",
		budgetSettingsTitle: "Budget Settings",
		titleRowHeader: "Name",
		activeRowHeader: "Active Status",
		addResolution: "Add New Category",
		modalHeader: "Add New",
		addNewCategory: "Add a new category",
		addNewLineItem: "Add new line item to an existing category",
		addNewLineItemPlaceholder: "Choose a category...",
		errorNoTitle: "Category must not be empty or all whitespace.",
		errorDuplicateTitle: "Category must be unique.",
		add: 'Add',
		cancel: "Cancel",
		edit: "Edit",
		saveResolution: "Save"
	},
	certificationText: {
		heading: "Manage Certification Text",
		placeholder: "Enter the Certification Text here...",
		actions: {
			resetToDefault: "Set to default text",
			edit: "Edit",
			save: "Save",
			cancel: "Cancel"
		},
		modal: {
			navigation: {
				cancelButtonLabel: "Go back",
				confirmButtonLabel: "Don't save",
				message: "There are unsaved changes. Go back to save your changes. Click \"Don't save\" to discard your changes.",
				title: "Unsaved changes",
			},
			confirmReset: {
				cancelButtonLabel: "Go back",
				confirmButtonLabel: "Overwrite Content",
				message: "Completing this action will overwrite the current content. Are you sure you want to do that?",
				title: "Overwrite Content",
			}
		}
	},
	manageResearchTeamRoles: {
		header: "Manage Research Team Roles",
		subHeader: "Research Team Roles",
		tableDescription: "Research team roles are managed within the Research Team Object on a record’s form. The active roles in the table below will be available for selection in the Research Team Object. Multiple roles with the same name should not be added.",
		actions: {
			save: "Save",
			cancel: "Cancel",
			edit: "Edit",
			addNew: "Add new role",
		},
		cancelEditModal: {
			header: "Discard Changes?",
			message: "There are unsaved changes. Are you sure you want to discard your changes?",
			cancel: "Cancel",
			discardChanges: "Discard Changes",
		},
		tableColumns: [ "Research Team Role", "Active Status" ],
		principalInvestigatorRoleNote: "This role is required and can be renamed but not inactivated"
	},
	components: {
		facetedSearchBar: {
			searchButtonAriaLabel: "Clear search",
		},
		simpleSearchBar: {
			searchButtonAriaLabel: "Clear search"
		},
		panelComponent: {
			modal: {
				deleteQuestion: {
					cancelButtonLabel: "Cancel",
					confirmButtonLabel:"Delete question",
					message: "This question is targeted by display logic that controls whether or not a question visible. Deleting this question may cause unexpected results. Are you sure you want to continue?",
					title: "Delete Question"
				}
			}
		}
	},
	researchTeam: {
		loading: "Loading...",
		addTeamMemberButton: "Add Team Member",
		removeTeamMemberButton: "Remove Team Member",
		addInternalAssociationButton: "Add Internal Association",
		addExternalAssociationButton: "Add External Association",
		removeAssociationButton: "Remove Association",
		effortFormatToggleLabel: "View Effort",
		effortFormatPercentage: "Percentage",
		effortFormatMonths: "Months",
		associationTypeToggleLabel: "Association Type",
		internalAssociationLabel: "Internal Association",
		externalAssociationLabel: "External Association",
		addGuest: "Add a new external team member",
		backToPersonSearch: "Back to person search",
		table: {
			internalAssociation: "Internal Association",
			credit: "Credit",
			costShareEffort: "Cost Share Effort",
			sponsoredEffort: "Sponsored Effort",
			totalEffort: "Total Effort",
			calendar: "Calendar",
			academic: "Academic",
			summer: "Summer",
		},
		inputLabels: {
			internalAssociation: "Internal Association",
			externalAssociation: "External Association",
			credit: "Credit",
			costShareEffort: "Cost Share Effort",
			sponsoredEffort: "Sponsored Effort",
			totalEffort: "Total Effort",
			calendarCostShareEffort: "Calendar Cost Share Effort",
			academicCostShareEffort: "Academic Cost Share Effort",
			summerCostShareEffort: "Summer Cost Share Effort",
			calendarSponsoredEffort: "Calendar Sponsored Effort",
			academicSponsoredEffort: "Academic Sponsored Effort",
			summerSponsoredEffort: "Summer Sponsored Effort",
		},
		modal: {
			removeTeamMemberTitle: "Remove team member?",
			removeTeamMemberDescription: "Remove team member",
			removeAssociationTitle: "Remove association?",
		},
		errors: {
			credit: "% of total credit has been allocated",
			internalAssociationHasBeenRemoved: "Effort fields are reference only. Team member is no longer affiliated with the internal association.",
		},
	},
};
